/**
 * ClientService
 *
 * This service handles all client-related operations in the application.
 * It provides methods for retrieving, creating, and managing client data,
 * as well as retrieving associated tasks and matter counts.
 *
 * @class
 */

import HttpService from './HttpService';
import {
  pathClientMatterId,
} from '@frontend/__settings__/septSoftwarePaths';

const http = new HttpService();

class ClientMattersService {
  /**
   * Retrieves all matters for a specific client
   *
   * @param {string} clientId - ID of the client
   * @returns {Promise<Array>} Array of matter objects for the client
   * @throws {Error} If the API request fails
   */
  static async getClientMatters(clientId: string): Promise<any[]> {
    const response = await http.get<any>(pathClientMatterId(clientId));
    
    // Handle various response formats
    // Case 1: Response is already an array
    if (Array.isArray(response)) {
      return response;
    }
    
    // Case 2: Response is wrapped { successful, data }
    if (response && response.successful && Array.isArray(response.data)) {
      return response.data;
    }
    
    // Case 3: Response has data but no successful flag
    if (response && Array.isArray(response.data)) {
      return response.data;
    }
    
    // Default: return empty array
    return [];
  }
}

export default ClientMattersService;
